export const CurrencyEnum = {
    EUR: 'EUR',
    USD: 'USD',
    GBP: 'GBP',
    ZAR: 'ZAR',
};
export const stringToCurrency = (isoCode) => {
    if (!isoCode) {
        return CurrencyEnum.EUR;
    }
    return (Object.values(CurrencyEnum).find((currency) => currency.toLowerCase() === isoCode.toLowerCase()) ?? CurrencyEnum.EUR);
};
export const createPriceObject = (amount, currency) => {
    return {
        amount,
        currency,
    };
};
export const formatPriceString = (amount, currency = 'EUR', locale = 'nl-NL', opts) => {
    const { nullable = true, hideCurrencySymbol = false, useGrouping = true, minimumFractionDigits = 2, maximumFractionDigits = 2, } = opts ?? {};
    if (nullable && (amount === null || amount === undefined)) {
        return undefined;
    }
    const style = hideCurrencySymbol ? 'decimal' : 'currency';
    return new Intl.NumberFormat(locale, {
        style,
        currency,
        minimumFractionDigits,
        maximumFractionDigits,
        useGrouping,
    }).format(typeof amount !== 'number' ? Number(amount) : amount);
};
const transformSameType = (value, transform) => {
    return (!value ? value : transform(value));
};
export const eurosToCents = (value) => transformSameType(value, (v) => Math.round(v * 100));
export const centsToEuros = (value) => transformSameType(value, (v) => v / 100);
//# sourceMappingURL=currency.js.map